import { Link } from '@tanstack/react-router';

import { t } from '@/shared/i18n';

import styles from './Brand.module.scss';

/**
 * Знак Flow Do: буква на акцентном квадрате и название.
 *
 * Логотипа пока нет — знак собран из типографики, чтобы не ждать его.
 * Когда появится, заменится здесь, в одном месте.
 */
export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/app" className={styles['brand']} aria-label={t.app.name}>
      <span className={styles['brand__mark']} aria-hidden="true">
        F
      </span>
      {!compact && <span className={styles['brand__name']}>{t.app.name}</span>}
    </Link>
  );
}
